<template>
  <validation-observer
    v-slot="{ invalid }"
    ref="rules"
    tag="div"
  >
    <pop-up
      :disabled="invalid"
      :spinning="updatingOrganization"
      button-text="Update"
      title="Update Organization Details"
      class="top-fade-in"
      @add="onSave"
      @close="$emit('close')"
    >
      <div class="row">
        <validation-provider
          #default="{ errors }"
          name="Organization Name"
          rules="required"
          tag="div"
          class="col-12"
        >
          <input-field
            name="organization_name"
            label="Organization Name"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="organization_name"
              v-model="organization.name"
              placeholder="Enter organization name here..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>

        <validation-provider
          #default="{ errors }"
          name="Address Line 1"
          rules="required"
          tag="div"
          class="col-12"
        >
          <input-field
            name="address_line1"
            label="Address Line 1"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="address_line1"
              v-model="organization.addressLine1"
              placeholder="Enter address line 1 here..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>

        <input-field
          name="address_line2"
          label="Address Line 2"
          label-position="top"
          class="col-12 mb-2"
        >
          <b-form-input
            id="address_line2"
            v-model="organization.addressLine2"
            placeholder="Enter address line 2 here..."
          />
        </input-field>

        <validation-provider
          #default="{ errors }"
          name="Country"
          rules="required"
          tag="div"
          class="col-12 col-md-6"
        >
          <input-field
            name="country"
            label="Country"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <!-- <v-select
              v-model="countryId"
              label="name"
              :options="countries"
              :state="errors.length > 0 ? false : null"
              :loading="fetchingCountries"
              placeholder="Select country here..."
              class="flex-fill distro-single-select"
            /> -->
            <b-form-select
              id="country"
              v-model="countryId"
              :selectable="option => option.value !== null"
              :state="errors.length > 0 ? false : null"
              :options="countryOptions"
            />
          </input-field>
        </validation-provider>

        <validation-provider
          #default="{ errors }"
          name="City"
          rules="required"
          tag="div"
          class="col-12 col-md-6"
        >
          <input-field
            name="city"
            label="City"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="city"
              v-model="organization.city"
              placeholder="Enter city here..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>

        <validation-provider
          #default="{ errors }"
          name="VAT Number"
          rules="required|integer"
          tag="div"
          class="col-12"
        >
          <input-field
            name="vat_number"
            label="VAT Number"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="vat_number"
              v-model="organization.vatNumber"
              placeholder="Enter vat number here..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>
      </div>
    </pop-up>
  </validation-observer>
</template>
<script>
import PopUp from '@/components/popup/Pop-up.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, integer } from '@validations'

// import vSelect from 'vue-select'

import countryOptions from '../../countries'

export default {
  components: {
    PopUp,
    ValidationProvider,
    ValidationObserver,
    // vSelect,
  },
  data() {
    return {
      required,
      integer,
      countryOptions,
      countryId: null,
      organization: null,
    }
  },
  computed: {
    updatingOrganization() {
      return this.$store.state.organization.updatingOrganization
    },
    organizationDetails() {
      return this.$store.state.organization.organization
    },
    countries() {
      return this.$store.state.organization.countries
    },
    fetchingCountries() {
      return this.$store.state.organizationfetchingCountries
    },
  },
  created() {
    this.organization = { ...this.organizationDetails }
    const country = countryOptions.find(c => c.text === this.organization.country)
    this.countryId = country.value
  },
  methods: {
    onSave() {
      const country = countryOptions.find(c => c.value === this.countryId)
      const organization = {
        name: this.organization.name,
        addressLine1: this.organization.addressLine1,
        addressLine2: this.organization.addressLine2,
        country: country.text,
        state: this.organization.state,
        city: this.organization.city,
        vatNumber: this.organization.vatNumber,
      }
      this.$store
        .dispatch('organization/updateOrganization', organization)
        .then(() => {
          this.$emit('close')
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating organization details.')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .paper {
    width: 100%;
    @media (min-width: 1200px) {
      width: 75%;
    }
  }
}
.distro-single-select::v-deep {
  .vs__dropdown-menu {
    max-height: 250px;
  }
}
</style>
